var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-lg modal-dialog-scrollable",
          attrs: { role: "document" }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h4", { staticClass: "modal-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("group.editModal.externalUsers.selectModal.title")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "div",
                  { staticClass: "btn-group mb-2" },
                  _vm._l(_vm.slottedTabs, function(slottedTab) {
                    return _c(
                      "TabButton",
                      {
                        key: slottedTab.id,
                        attrs: { tab: slottedTab.id },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(slottedTab.title) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "ExternalUserSelectModalTab",
                  {
                    attrs: {
                      id: "contacts",
                      title: _vm.$t(
                        "group.editModal.externalUsers.selectModal.tabContacts.title"
                      )
                    }
                  },
                  [_c("TabContacts")],
                  1
                ),
                _vm._v(" "),
                _vm._t("externalUserSelectModalTabs")
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: { click: _vm.onAdd }
                },
                [_vm._v(_vm._s(_vm.$t("btnAdd")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }